<h1 mat-dialog-title>Wollen Sie diese Spesen löschen?</h1>
<div mat-dialog-actions>
  <button mat-button [mat-dialog-close]="false" cdkFocusInitial>Abbrechen</button>
  <button mat-button [mat-dialog-close]="true">Löschen</button>
</div>
